var cart=true;
var showInstalmentOrdersRequiringActionsForNextAction=false;
var previousPaymentOperator=false;
var warrantyConflictModalClosedfromButton = false;

function fancyErrorLink(){
	$('a.errorLink').data('type', $("#pageType").val());
}
function checkWarrantyUA(){
	if(window.sessionStorage.getItem('sdfghytu') != "1"){
		$('.cart-warranty-box').each(function(){
			window.sessionStorage.setItem('sdfghytu', "1");
			var $button = $(this).find('.js-select-warranty.selected').first();
			if($button.length && $button.data('id')>3){
				app.logEvent({
					"id": "Przedluz gwarancje K1",
					"f03": "Przedluz Gwarancje® wariant " + $button.find('.name').text(),
					"f04": $button.data('type') == 'ONE_TIME' ? 'Płatność jednorazowa' : 'Płatność miesięczna',
					"f05": $(this).data('plu')
				});
			}
		});
	}
}

function toggleWarrantySubscriptionPaymentMessage(paymentType) {
	if (paymentType == 4) {
		$('#js-card-description').removeClass('is-hidden');
	} else {
		$('#js-card-description').addClass('is-hidden');
	}
	if (paymentType != 5 && paymentType != 12 && paymentType != 4) {
		$('#js-no-card-description').removeClass('is-hidden');
	} else {
		$('#js-no-card-description').addClass('is-hidden');
	}
}

function changeOperatorSource(source, element) {
	$('.sources .active').removeClass('active');
	$(element).addClass('active');
	$('.operator_source_form').each(function () {
		$(this).val(source);
	});
}

function sendK4HoursShopEvent(deliveryType) {
	var $li = $('.timeDeliveryList ul.group li');
	var $active = $li.find('input:checked').closest('li');
	if ($active.length) {
		var data = {
			id: 'k4_przedziały_czasowe',
			f03: document.location.href,
			f04: textData($active),	// wybrany pprzedział
			f05: deliveryType,
			f06: "0",
			f07: "0",
			f08: "0",
			f09: "0",
			f10: "0",
			f11: "0",
			f12: "0",
			f13: "0",
			f14: "0"
			
		}
		function textData($element) {
			let n = $element.find('.name').text();
			if (n && n.length) {
				let p = $element.find('.price').text();
				return n + ' / ' + ($element.is('.notActive') ? 'niedostępny' : 'dostępny') + ' / ' + (p.length ? p : '0');
			} else { 
				return false;
			}
		}
		$li.each(function (i, element) {
			var index = 'f' + (i + 6);
			if (i < 9) { 
				if (index.length == 2) {
					index = index.substr(0, 1) + '0' + index.substr(1, 1);
				}
				let text = textData($(element));
				if (text) {
					data[index] = text;
				}
			}
		});
		if (data.f04) {
			app.logEvent(data);
		}
	}
}
function sendK4DayShopEvent(deliveryType) {
	var $li = $('.deliveryDayList li');
	var $active = $li.find('input:checked').closest('li');
	if ($active.length) {
		var data = {
			id: 'k4_data_dostawy',
			f03: document.location.href,
			f04: textData($active),
			f05: deliveryType,
			f06: "0",
			f07: "0",
			f08: "0",
			f09: "0",
			f10: "0",
			f11: "0",
			f12: "0"
		}
		function textData($element) {
			let d = $element.find('.deliveryDayDate').val();
			if (d && d.length) {
				d = d.split('-');
				let p = $element.find('.deliveryName span');
				return d[2] + '.' + d[1] + ' / ' + ($element.is('.notActive') ? 'niedostępny' : 'dostępny') + ' / ' + (p.length ? p.text() : '0');
			} else {
				return false;
			}
		}
		$li.each(function (i, element) {
	
			var index = 'f' + (i + 6);
			if (i < 7) {
				if (index.length == 2) {
					index = index.substr(0, 1) + '0' + index.substr(1, 1);
				}
				let text = textData($(element));
				if (text) {
					data[index] = text;
				}
			}
		});
		if (data.f04) {
			app.logEvent(data);
		}
	}
}
function changeDeliveryPrice() {
	$.ajax({
		url: '/order-path-time-select-interval.ltr',
		async: false,
		dataType: 'json',
		type: 'POST',
		cache: false,
		data: {
			selected_interval: $('#selected_interval').val(),
			refresh: true
		},
		success: function (json) {
			standardCartPreviewForOrderPathSuccess(json);
			$('#stdDeliveryPrice').text($('#mainStdDeliveryPrice').text());
			$('#additionalTransportPrice').text($('#mainAdditionalTransportPrice').text());
			$('#deliveryPrice').text($('#mainOrderDeliveryPrice').text());
		}
	});
}
function changeServiceBox(id,service,typ){
	var input=$('#fancybox-content #servicesBoxLayer_'+id+'_'+service);
	var input2=$('#servicesBoxLayer_'+id+'_'+service);
	var rel=parseInt($('#productCount'+id+'_'+service).val()) || 1;
	var value=parseInt(input.val()) || rel;
	if(value<rel && typ=='+'){
		value++;
	} else if(value>0 && typ=='-'){
		value--;
	}
	value=Math.min(value,rel);
	value=Math.max(value,0);
	input.val(value);
	input2.val(value);
}

function InvoiceForm(force) {
	if($('#company:checked').length){					//firma
		$('#companyText').addClass('bold');
		$('#individualText').removeClass('bold');
		$('#peselBox').hide();
		$('#pesel').ignore(true).val('');
		$('#nipBox').show();

		$('#orderInvoiceNipBox label.lab').html('NIP:<em>*</em>');
		$('#invoiceAddressSurname, #invoiceAddressFirstname').ignore(true);

		if($('#invoiceNeeded:checked').length){
			$('#invoice-company-name-textarea').ignore(true);
			$('#orderInvoiceNipBox').addClass('individual');
			$('#orderInvoiceNip').addClass('individual');
			
		}else{
			$('#invoiceAddressFirstnameBox, #invoiceAddressSurnameBox').hide();
			$('#orderInvoiceNameBox').show();
			$('#orderInvoiceNipBox').removeClass('individual');
			$('#invoice-company-name-textarea').ignore(false);
			$('#orderInvoiceNip').ignore(false).removeClass('individual');

		}
		$('#userNip').removeClass('individual');
		if($('#userNip').val()=='')$('#userNip').val($('#orderInvoiceNip').val());


	}else{												//prywatne zakupy
		$('#individualText').addClass('bold');
		$('#companyText').removeClass('bold');
		$('#orderInvoiceNameBox').hide();

		$('#invoice-company-name-textarea').ignore(true);
		$('#invoice-company-name, #invoice-company-name-cd').val('');
		$('#orderInvoiceNipBox').addClass('individual');
		$('#orderInvoiceNip').addClass('individual').val('').trigger('input');
		setTimeout(function(){
			if($('#orderInvoiceNip').hasClass('error')){
				$('#frontForm').validate().element('#orderInvoiceNip');
				if($('#orderInvoiceNip').val()=='')$('#orderInvoiceNip')[0].keyup();
			}
		},100);
		if($('#invoiceAddressFirstname').hasClass('error'))$('#frontForm').validate().element('#invoiceAddressFirstname');
		if($('#invoiceAddressSurname').hasClass('error'))$('#frontForm').validate().element('#invoiceAddressSurname');
		$('#peselBox').show();
		$('#pesel').ignore(false);
		$('#nipBox').hide();
		$('#userNip').addClass('individual').val('').trigger('input');
		if($('#invoiceNeeded:checked').length){			//prywatne + identyczne dane faktury
			$('#invoiceAddressSurname, #invoiceAddressFirstname').ignore(true);
		}else{											//prywatne + inne dane faktury
			$('#invoiceAddressFirstnameBox, #invoiceAddressSurnameBox').show();
			$('#orderInvoiceNipBox label.lab').html('NIP:');
			$('#invoiceAddressFirstnameLabel').html('Imię: <em>*</em>');
			$('#invoiceAddressSurnameLabel').html('Nazwisko: <em>*</em>');
			$('#invoiceAddressSurname, #invoiceAddressFirstname').ignore(false);
		}
	}

	if($('#invoiceNeeded').is(':checked')){
		$("#invoice-data").slideUp();
		$('#invoiceNeededF').addClass('bold');
		$('#invoiceNeededT').removeClass('bold');
		$("#invoice-data input").not('.company').ignore(true);
		$("#invoice-data .errorBox").removeClass('statusError').removeClass('statusOk');
		$("#invoice-data span.errorText").text('');
		if($('#invoiceSelect').val()=='0')invoiceAddressSwitch(force);
		else {
			updateInvoiceData($('#invoiceSelect').val());
		}
	} else {
		$("#invoice-data input").not('.company').ignore(false);
		$('#invoice-data').slideDown();
		$('#invoiceNeededF').removeClass('bold');
		$('#invoiceNeededT').addClass('bold');
	}
}

function removeUnavailableProducts() {
	loadingStart();
	$.ajax({
		url: 'order-remove-unavailable-products.ltr',
		type: 'POST',
		success: function(html) {
			document.location.href = '/cart.bhtml';
		},
		error: function() {
			loadingStop();
			app.alert('Błąd usuwania produktów niedostępnych');
		}
	});
}

function deletePartnerSubscription(productId, partnerSubscriptionId){
	loadingStart();
	$.ajax({
		url: '/remove-partner-subscription.ltr',
		method: 'POST',
		dataType: 'json',
		data: {
			partnerSubscriptionId: partnerSubscriptionId,
			productId: productId
		},
		cache: false,
		complete: function complete(json) {
			if (json.responseJSON && json.responseJSON.status === 'FAIL') {
				loadingStop();
				$.fancybox('<div class="w350"><div class="f14 bold tcenter">'
					+ json.messages
					+ '</div><div class="clear"></div><div class="buttonA h30 mT10"><a onclick="$.fancybox.close()" class="ok btn btn-primary" href="javascript:void(0)">OK</a><div class="clear"></div></div></div>',{
					autoDimensions:	true
				});
			} else {
				window.location.reload();
			}
		}
	});
}
function permissions(){
	$('#old-permissions input').click(function(){
		$('#old-permissions').addClass('loading');
		setTimeout(function(){
			$('#old-permissions').remove();
			$('#perrmissionBox').removeClass('old-mode');
			$('#permissions-displayed').val('true');
		},1000);
	});
}

function showModalAddressError(data, callback){

	var message = data.message;
	var isAnyProductESD = data.isAnyProductElectronicSoftwareDistribution === true;
	var isAddressValid = data.isAddressValid === true;
	var isInvoiceAddressValid = data.isInvoiceAddressValid === true;
	var isDeliveryAddressValid = data.isDeliveryAddressValid === true;

	var buttons = [
		{
			text:"Tak",
			cssClass: "btn-second",
			click:function(){
				app.closeModal();
				scrollToAddressValidate(isAddressValid, isDeliveryAddressValid, isInvoiceAddressValid);
			}
		},{
			text:"Nie, idę dalej",
			cssClass: "btn-fourth",
			click:function(){
				app.closeModal();
				callback();
			}
		}
	];

	if(isAnyProductESD) {
		buttons = [
			{
				text:"Edytuj",
				cssClass: "btn-second",
				click:function(){
					app.closeModal();
					scrollToAddressValidate(isAddressValid, isDeliveryAddressValid, isInvoiceAddressValid);
				}
			}
		]
	}
	loadingStop();
	app.showModal({
		id:'adress-validate-modal',
		content: data.message,
		buttons: buttons
	});
}

function showModalBlockPayment(data){
	loadingStop();
	app.showModal({
		id:'adress-validate-modal',
		content: data.message,
		buttons: [{
			text: 'OK',
			cssClass: 'btn-primary',
			click:function(){
				app.closeModal();
			}
		}]
	});
}

function scrollToAddressValidate(isAddressValid, isDeliveryAddressValid, isInvoiceAddressValid){

	if(!isAddressValid){
		$('#userBox').addClass('home-address-invalid').find('.home-address-invalid-message').show();
	}else{
		$('#userBox').removeClass('home-address-invalid').find('.home-address-invalid-message').hide();
	}

	if(!isDeliveryAddressValid){
		$('#delivery-address').addClass('delivery-address-invalid').find('.delivery-address-invalid-message').show();
	}else{
		$('#delivery-address').removeClass('delivery-address-invalid').find('.delivery-address-invalid-message').hide();
	}

	if(!isInvoiceAddressValid){
		$('#invoice-data').addClass('invoice-address-invalid').find('.invoice-address-invalid-message').show();
	}else{
		$('#invoice-data').removeClass('invoice-address-invalid').find('.invoice-address-invalid-message').hide();
	}

	if(!isAddressValid){
		$.scrollTo($('#userBox'),800);
		$('#userBox .zipCode').focus();
	}else if(!isDeliveryAddressValid){
		$.scrollTo($('#delivery-address'),800);
		$('#delivery-address .zipCode').focus();
	}else if(!isInvoiceAddressValid){
		$.scrollTo($('#invoiceForm'),800);
		$('#invoiceForm .zipCode').focus();
	}
}

function supplementPaymentValidate(){
	$('#frontForm').validate({
		rules:{
			"ePaymentBank":{
				required:true,
				minlength:1
			},
			"ePaymentBankBluemedia":{
				required:true,
				minlength:1
			},
			"termsAccepted":{
					required: true
			},
			"eTransferBankId":{
				required: true
			}
		},
		messages:{
			"ePaymentBank":{
				required: "Wybierz bank"
			},
			"termsAccepted":{
				required: "Wybór płatności wymaga akceptacji regulaminu"
			},
			"ePaymentBankBluemedia":{
				required: "Wybierz bank, w którym posiadasz internetowe konto osobiste"
			},
			"eTransferBankId":{
				required: "Wybierz bank"
			}
		}
	});
}
function showPayuPriceLimitMessage(){
	if($('#payu-price-limit-message').length) {
		var $payuErrorMessageBlock = $('#payu-price-limit-message');
		var messageHtml = $payuErrorMessageBlock.find('.payu-limit-message').html();
		app.showModal({
			id:'modal-payu-price-limit-message',
			closeOnEscape:false,
			close:false,
			content: messageHtml,
			buttons: [
				{
					text: 'WRÓĆ DO WYBORU PŁATNOŚCI',
					cssClass: 'btn-fourth',
					click:function(){
						app.closeModal();
						$('.js-back').click();
					}
				},
				{
					text: 'WYBIERAM INNY TERMIN',
					cssClass: 'btn-third',
					click:function(){
						app.closeModal();
					}
				}
			]
		});
		return false;
	}
}

function standardCartPreviewForOrderPathSuccess(json){
	if(json && json.status){
		if(json.status === 'OK'){
			//jest ok
		}else if(json.status === 'INVALID_STAGE' && json.message){
			app.alert(json.message)
		}else if(json.status === 'ORDER_ABSENCE'){
			loadingStart();
			document.location.href="/cart.bhtml";
			return;
		}else if(json.status === 'FORBIDDEN_ACTION'){
			//nie można wykonać akcji
		}
	}
	var url = $('#form1').length ? '/order-path-cart-preview.ltr': '/order-path-preview.ltr';
	$.ajax({
		url:url,
		data:{
			refresh: true
		},
		async: false,
		success:function(html){
			$('#basket-small').empty().html(html);
			if($('#deliveryPrice').length && $('#mainOrderDeliveryPrice').length){
				$('#deliveryPrice').text($('#mainOrderDeliveryPrice').text());
			}
			giftCardAmountToCoverByCashSet();
			checkbox('#basket-small .priceDisplayType');
			LastStageBeforFinalize();
			showPayuPriceLimitMessage();
			paymentOperator.change($('#paymentOperator').val(), $('#paymentOperatorRegulationUrl').val());
			
		}
	});
}

var paymentOperator = function () {
	var $agreement, $self;
	var currentOperator;
	var checkTerm = {
		PLATNOSCI: false,
		TPAY: false,
		P24: false
	}


	function init(paymentOperator, regulationUrl) {
		$self = $('#permissions');
		if ($self.length) {
			$agreement = $('#payment-agreement', $self);
			currentOperator = paymentOperator;
	
			$agreement.on('click', function () {
				saveTermSelected();
			});
			setRegulationUrl(paymentOperator, regulationUrl);
			saveTermSelected();
		}
	}
	function setValidate(ignore) {
		$agreement.ignore(ignore);
	}

	function saveTermSelected() {
		if (currentOperator) {
			checkTerm[currentOperator] = $agreement.is(':checked');
		}
	}
	function setRegulationUrl(operator, regulationUrl) {
		var $div = '';
		if (regulationUrl) {
			if (operator == 'PLATNOSCI') {
				$div = $('#payu-regulation a');
				$('#payu-regulation a').attr('href', regulationUrl);
			} else if (operator == 'TPAY') {
				$('#tpay-regulation a').attr('href', regulationUrl);
			} else if (operator == 'P24') {
				$('#p24-regulation a').attr('href', regulationUrl);
			}
			if ($div.length) {
				$div.attr('href', regulationUrl);
			}
		}
	}
	function change(operator, regulationUrl) {
		if ($self && $self.length) { 
			if (typeof operator === "string" && typeof regulationUrl === "string") {
				if (operator.length == 0) {
					console.log('Brak operatora');
					setValidate(true);
					$self.removeClass("tpay payu p24");
				} else if (currentOperator == operator) {
					console.log(`Ten sam operator: ${operator}`);
				} else {
					console.log(`Zmiana operatora z '${currentOperator}' na ${operator}`);
					setValidate(false);
					$self.removeClass("tpay payu p24");
					if (operator == 'PLATNOSCI') {
						$self.addClass("payu");
					} else if (operator == 'TPAY') {
						$self.addClass("tpay");
					} else if (operator == 'P24') {
						$self.addClass("p24");
					}
					setRegulationUrl(operator, regulationUrl);
					if (operator.length) {
						$agreement.prop('checked', checkTerm[operator]);
					}
				}
				currentOperator = operator;
			} else {
				alert('Błąd zapisywania danych płatności. Spróbuj ponownie')
			}
		}
	}
	return {
		init, change
	}
}();

// TODO EUROTMYE-74
function updatePaymentBank(bankId) {
	console.log('UPDATE PAYMENT BANK with bankId:' + bankId);
	$.ajax({
		url: '/order-path-payment-select-e-payment-bank.ltr',
		cache: false,
		type: 'POST',
		dataType: 'json',
		async: false,
		data: {
			ePaymentBankId: bankId
		},
		success: function (json) {
			standardCartPreviewForOrderPathSuccess(json);
		}
	});
}

function paymentOperatorChange(paymentOperator, paymentOperatorRegulationUrl) {
	$('#tpay-regulation a').attr('href', paymentOperatorRegulationUrl);
}
var esdProducts = false;
	
function checkEsdDelayed(){
	if($('#esd-delayed').length){
		$.fancybox({
			href:'#esd-delayed'
		},{
			hideOnOverlayClick:false,
			showCloseButton:false,
			enableEscapeButton:false,
			autoDimensions:	true
		});
	}

}

function toggleInvoiceInfo() {
	$('.invoice-container').addClass('expanded');
}

function togglePaperInvoiceDeliveryMessage(selected) {
	selected ? $('#address-delivery-paper-invoice-message').addClass('show') : $('#address-delivery-paper-invoice-message').removeClass('show');
}

function preValidateForm(callback){
	if(esdProducts){
		loadingStart();
		$.ajax({
			url:'/order-path-preFinalizationValidation.ltr',
			type:'POST',
			success:function(json){
				loadingStop();
				if(json.hasError){
					$.fancybox('<div class="w300"><div>'+json.errorMessage+'</div><div class="mT10 buttonA"><a class="btn btn-third btn-prev" href="#">Przerwij zakupy</a><a class="btn btn-primary btn-next" href="#">Kontynuj</a><div class="clear"></div></div></div>',{autoDimensions:true,onComplete:function(){
						$('#fancybox-content .btn-next').click(function(){
							$.fancybox.close();
							callback();
						});
						$('#fancybox-content .btn-prev').click(function(){
							$.fancybox.close();
						});
					}});
				}else{
					callback();
				}
			},error:function(){
				console.log('błąd sprawdzania formularza');
			}
		});
	}else{
		callback();
	}
}

function reloadCart() {
	loadingStart();
	document.location.reload(true);
}

const voucherService = (function() {

	function applyVoucher(voucherCode) {
		loadingStart();
		return $.ajax({
			method: 'POST',
			url: '/applyVoucherToCart.ltr',
			dataType: 'json',
			data: { voucherCode },
			success:function(){
				loadingStop();
			},error:function(){
				app.alert('Błąd dodawania kodu rabatowego')
			}
		});
	}

	function removeVoucher(voucherCode) {
		loadingStart();
		return $.ajax({
			method: 'POST',
			url: '/removeVoucherFromCart.ltr',
			dataType: 'json',
			data: { voucherCode },
			success:function(){
				loadingStop();
			},error:function(){
				app.alert('Błąd usuwania kodu rabatowego')
			}
		});
	}

	function enableAutoVouchers() {
		return $.ajax({
			method: 'POST',
			url: '/enableAutomaticVouchers.ltr'
		});
	}

	function disableAutoVouchers() {
		return $.ajax({
			method: 'POST',
			url: '/disableAutomaticVouchers.ltr'
		})
	}

	function isVoucherApplied() {
		return $('.voucher-control')
			.find('button:visible')
			.hasClass('remove-voucher');
	}

	function handleInputKeyup(e) {
		if (e.keyCode === 13 && !isVoucherApplied()) {
			applyVoucherAction();
		}

		if (e.target.value !== e.target.defaultValue) {
			$('.voucher-control').removeClass('voucher-added');
		} else if (e.target.value) {
			$('.voucher-control').addClass('voucher-added');
		}
	}

	function redirectOrReloadAfterVoucherApply(res)  {
		if (res.errorMessage.length > 0) {
			app.alert(res.errorMessage);
		} else if (res.loginNeeded) {
			loadingStart();
			document.location.href = res.loginUrl;
		} else {
			reloadCart();
		}
	}

	function applyVoucherAction() {
		var voucher=$('#voucherInput').val();

		if(voucher.length > 0 && !/^[0-9a-zA-Z._-]+$/.test(voucher)) {
			showInvalidVoucherMessage();
			return false;
		}

		const voucherCode = $('#voucherInput').val();
		const voucherCodeHasChagned = $('#voucherInput').prop('defaultValue') !== voucherCode;

		if (!voucherCodeHasChagned) {
			return false;
		}

		if (voucherCode) {
			applyVoucher(voucherCode).then(redirectOrReloadAfterVoucherApply).fail(errorMessage);
		} else {
			removeVoucherAction();
		}
	}
	function errorMessage(){
		app.alert('Niepoprawny kod rabatowy');
	}

	function handleApplyVoucherClick() {
		applyVoucherAction();
	}

	function removeVoucherAction() {
		const voucherCode = $('#voucherInput').prop('defaultValue') || $('#voucherInput').val();

		removeVoucher(voucherCode).then(reloadCart);
	}

	function handleRemoveVoucherClick() {
		removeVoucherAction();
	}

	function setEvents() {
		$('body')
			.on('click', '.js-apply-voucher', handleApplyVoucherClick)
			.on('click', '.js-remove-voucher', handleRemoveVoucherClick)
			.on('click', '.js-enable-auto-vouchers', () => enableAutoVouchers().then(reloadCart))
			.on('click', '.js-disable-auto-vouchers', () => disableAutoVouchers().then(reloadCart));

		$('#voucherInput').keyup(handleInputKeyup);
	}

	function init() {
		setEvents();
	}

	return {
		init,
		applyVoucher,
		removeVoucher: removeVoucherAction,
		enableAutoVouchers,
		disableAutoVouchers
	}
})();

$( document ).ready(function() {

	$('body')
		.on('click', '.js-resolve-warranty-payment-conflict', resolveSubscriptionWarrantyPaymentConflict)
		.on('change', '.product-warranty-options input[name^=warranty-id]', function validateWarrantyOptions() {
			$(this).parents('.product-warranty-wrapper').removeClass('error');
		});

	setPostponedInfo();

	if ($('#voucherInput').length) {
		voucherService.init();
	}

	if($('.split-payment-message').length) {
		$.fancybox($('.split-payment-message').html(), {
			autoDimensions:	true,
			padding: 10
		});
	}

});

function resolveSubscriptionWarrantyPaymentConflict() {

	if (allRequiredWarrantyOptionsSelected()) {
		const requestData = $('.product-warranty-options').map(createRequestData);

		resolveSubscriptionWarrantyPaymentConflictRequest(JSON.stringify({warrantiesToUpdate: requestData.toArray()}))
			.then(() => validateServicesAndContinue())
			.fail(() => fancyAlert('Wystąpił błąd przetwarzania. Prosimy odświeżyć stronę i spróbować jeszcze raz.'));
	}
}

function allRequiredWarrantyOptionsSelected() {
	let isValid = true;

	$('.product-warranty-options').each(function() {
		let $selectedOption = $(this).find('input[name^=warranty-id]').filter(":checked");

		if (!$selectedOption.length) {
			isValid = false;
			$(this).parents('.product-warranty-wrapper').addClass('error');
		}
	});

	return isValid;
}

function createRequestData() {
	const warrantyId = $(this).find('input[name^=warranty-id]').filter(':checked').val();
	warrantyConflictModalClosedfromButton = true;
	UA.interaction('PG ABO na Raty','Kliknięcie', warrantyId == '' ? 'Rezygnacja z PG' : 'Proponowany PG');

	if (!warrantyId) return;

	const productId = $(this).find('input[name^=product-id]').val();
	const suiteCode = $(this).find('input[name^=suite-code]').val();

	return {
		productId,
		suiteCode,
		warrantyId
	};
}

function resolveSubscriptionWarrantyPaymentConflictRequest(data = {}) {
	return $.ajax({
		url: "/order-path-resolve-warranty-payment-conflict.ltr",
		type: "POST",
		contentType: 'application/json',
		data
	});
}

function initialInstalmentCalculator() {
	var $self = $('#instalment-calculator');
	var $rate = $('.expected-rate');
	if($self.length) {
		if(!$rate.val() && $self.data('max-instalment-worth') > 0) {
			$rate.val($self.data('max-instalment-worth')).change();
			instalmentCalculator();
		}
		$(document).on('cartReady',function(event,data){
			if(data && data.summary){
				$self.data('cart-worth', data.summary.price.toString().replace(/\s/g, '').replace(',', '.'));
				instalmentCalculator();
			}
		});
		if(app.pageType()=='precart'){
			$('#left-column .dalej2').attr('href','#').click(function(event){
				event.preventDefault();
				loadingStart();
				var $form=$('<form method="POST" action="'+document.location.pathname+'"><input type="hidden" name="clientMaxInstalmentWorth" value="'+$('#instalment-calculator .expected-rate').val()+'"/></form>');
				$form.appendTo($('#to_cart'));
				$form.submit();
			});
		}
	}
}

function changePaymentTypeForSameDayDeliveryType() {
	$.fancybox.close();
	loadingStart();
	$.ajax({
		url: '/order-path-change-payment-type.ltr',
		async: false,
		dataType : 'json',
		type: 'POST',
		data: {
			refresh: true
		},
		success: function(json){
			loadingStop();
			formActionNext();
		}
	});
}

function instalmentCalculator() {
	var $self = $('#instalment-calculator');
	var cartWorth = $self.data('cart-worth');
	var maxCartWorth = $self.data('max-cart-worth');
	var value = $('.expected-rate').val();
	var expectedWorth = value.replace(',', '.');
	var remainingWorth = $self.data('instalment-number') * expectedWorth - $self.data('cart-worth');
	var highExpectedWorth = value * $self.data('instalment-number') > maxCartWorth ? true : false;
	var $optionInstalments = $('.max-instalment-options, .selected-instalment-options, .instalment-option .instalment-pricing');
	if(Number(cartWorth) + remainingWorth > maxCartWorth) {
		remainingWorth = maxCartWorth - cartWorth;
	}

	$('.remaining-worth').val(remainingWorth.toFixed(2));

	if(remainingWorth < 0) {
		$self.addClass('error low-rate-error');
	} else {
		$self.removeClass('low-rate-error');
	}
	if (highExpectedWorth) {
		$self.addClass('error over-max-rate-error');
	} else {
		$self.removeClass('over-max-rate-error');
	}
	if(remainingWorth >= 0 && !highExpectedWorth) {
		$self.removeClass('error');
	}
	if($optionInstalments.length){
		$optionInstalments.each(function(){
			var count = $(this).data('i')/1;
			if(cartWorth/count>expectedWorth){
				$(this).addClass('error');
			}else{
				$(this).removeClass('error');
			}
		})
	}
}

function instalmentOrdersRequiring(){
	$.fancybox($('#instalmentOrdersRequiringActions').parent().html(),{
		autoDimensions:true,
		onClosed:function(){
			if(showInstalmentOrdersRequiringActionsForNextAction){
				showInstalmentOrdersRequiringActionsForNextAction=false;
				zamawiam();
			}
		}
	});
}

function euroInsurance(){
	var v=$('#insuranceDamageNumber').val();
	if($('#euroInsuranceType').prop('checked')){
		$('#insuranceBox').show();
		var t=$('#insuranceDamageNumberOther').html();
		$('#insuranceDamageNumberOther').html('');
		$('#insuranceDamageNumberEuro').html(t);
	}else{
		$('#insuranceBox').hide();
		var t=$('#insuranceDamageNumberEuro').html();
		$('#insuranceDamageNumberEuro').html('');
		$('#insuranceDamageNumberOther').html(t);
	}
	$('#insuranceDamageNumber').val(v);
}
function goToEcardAlert(time, messageId){
	window.time=time;
	var opt={
		hideOnOverlayClick:false,
		showCloseButton:false,
		enableEscapeButton:false,
		autoDimensions:true,
		onComplete:function(){
			goToEcardCount(window.time);
		}
	};

	$.fancybox({
		href: messageId
	},opt);
}

function showLayerMessage(messageId){
	var opt={
			autoDimensions:true
	};
	$.fancybox($(messageId).html(),opt);
}

function goToEcardCount(time){
	time--;
	window.time=time;
	var t=time+' ';
	if(time==1)t+='sekundę';
	else if(time%10>1 && time%10<5)t+='sekundy';
	else t+='sekund';
	$('#fancybox-content #eCardCount').length > 0 ? $('#fancybox-content #eCardCount').html(t) : $('#fancybox-content #eCardCountNumber').html('('+time+')');
	if(time>0){
		setTimeout("goToEcardCount(time)",1000);
	}
	if(time==0){
		if($('#fancybox-content .place').length){
			$('#fancybox-content .place')[0].click();
		}
	}
}
function addToCardAccessories(id, name){
	if(pageType=='cart'){
		addPromotedProduct(id);
	}else if(pageType=='precart'){
		addToCard(id,name,'TO_CART');
		$('#acc'+id).prop('checked',true);
	}
}

function showDeliveryNotify() {
	sendServiceEvent($(homeDeliveryPromotionMessage).find('input[name="eventTypeName"]').val());
	$.fancybox(homeDeliveryPromotionMessage,{
		autoDimensions:	true,
		onComplete:function(){
			$('#fancybox-outer').find('.noSafari').removeClass('noSafari');
			checkbox('#fancybox-outer');
			setServiceInfo('#fancybox-content');
		}
	});
}
function tradeDoublerConfirm(orderNumber){
	var url = '/order-path-trade-doubler-confirm.ltr?orderNumber='+orderNumber;
	$.ajax({
	   type: "GET",
	   url: url
	 });

}

function setTabIndex() {
	var currentIndex = 1;

	$('input[type="text"], input[type="password"]').each(function() {
		var $element = $(this);
		var name = $element.attr('name');

		//inputy houseNumber i flatNumber są generowane w odwrotnej kolejności - ich indeksy muszą być ze sobą zamienione
		if(name && name.indexOf('houseNumber') > -1) {
			$element.attr('tabindex', currentIndex - 1);
		} else if (name && name.indexOf('flatNumber') > -1) {
			$element.attr('tabindex', currentIndex + 1);
		} else {
			$element.attr('tabindex', currentIndex);
		}

		currentIndex++;
	});
}

function showDeliveryPriceDetails() {
	$('#row2').show();
	$('#row3').show();
	$('#row4').hide();
}
function showContactMsg() {
	$('#row2').hide();
	$('#row3').hide();
	$('#row4').show();
}
function setSelectedInterval(position) {
	$('#selected_interval').val(position);
}

function fancyRegulamin(){
	$('#regulamin').fancybox({
		width: 1000,
		height: 480,
		type:'iframe'
	});
}

function formAction(action) {
	$('#F_ACTION').val(action);
	loadingStart();
	$('#frontForm')[0].submit();
}

function precartReload(){

}

function checkZipCode( $input ) {
	return $input.length && /\d{2}-\d{3}/.test( $input.val() );
}

function customerPaymentCalculate(replace){
	var insurerPayment=$('#insurerPayment');
	var customerPayment=$('#customerPayment');

	var summaryPayment=parseFloat($('#summaryPayment').val().replace("&nbsp;","").replace(",","."));
	var maxInsurerPaymentValue=parseFloat($('#maxInsurerPaymentValue').val().replace("&nbsp;","").replace(",","."));
	var insurerPaymentValue=parseFloat(insurerPayment.val().replace(/\s/, "").replace(",","."));

	if(replace && insurerPaymentValue>maxInsurerPaymentValue){
		insurerPaymentValue=maxInsurerPaymentValue;
		insurerPayment.val(maxInsurerPaymentValue.toString().replace(".",","));
	}

	var customerPaymentValue=summaryPayment-insurerPaymentValue;

	if(customerPaymentValue<0 || isNaN(customerPaymentValue))customerPaymentValue=0;
	else {
		customerPaymentValue=Math.round(customerPaymentValue*100)/100;
		customerPaymentValue=customerPaymentValue.toString().replace(".",",");
	}
	customerPayment.val(customerPaymentValue);
}

var hideTimer = null;
var loadOption=[];
var hideDelay =200;
var startDelay=500;
moveContainerId='';

function kalkulatorCreditAgricoleEvents(obj){
	//nadpisywane przez Euro
}

function logReg(i) {}

function nip(){
	$(".nip").keyfilter(/[\d\-]/).keyup(function(){
		if($(this).hasClass('individual') && $(this).val()==''){
			   $(this).parents('.statusError').addClass('statusOk').removeClass('statusError');
		}
	});
}

function showMaxCountMessage(maxCount) {
	var isOperatorLogged = window.sessionStorage.getItem('operator-logged')==="true";
	var ending = maxCount == 1 ? 'sztukę' : (maxCount < 5 || (maxCount > 20 && maxCount%10 >= 2 && maxCount%10 < 5)) ? 'sztuki' : 'sztuk';
	var headerHtml = `${isOperatorLogged ? 'Klient może': 'Możesz' } kupić maksymalnie ${maxCount} ${ending} tego produktu`;
	var contentHtml = $('#cart-max-product-count-message').html();
	app.showModal({
		id:'modal-product-max-count',
		header: headerHtml,
		content: contentHtml,
		callbackOpen: function() {
			UA.push({
				event: 'visitorInteraction',
				eventCategory: 'B2B', 
				eventAction: 'Komunikat - limit sztuk - Wyświetlenie', 
				eventLabel: 'Wyświetlenie'
			})
		}
	});
}

function addPrzelicz(){
	var p=$('.cart_summarize tr.pp:last').find('.addPrzelicz');
	p.wrapInner('<div class="relative tcenter"></div>').find('.relative').append('<a onclick="calculateCart();return false;" title="Przelicz koszyk" href="javascript:void(0);" style="display:none;" class="przelicz btn btn-fourth">Przelicz</a>');
}

function focusPrzelicz(){
	var p=$('.cart_summarize tr.pp:last');
	var r=parseInt(p.height())-5;//+5
	if(p.hasClass('prod'))r-=13;
	if(p.hasClass('uslugi'))r-=5;
	$('.voucherPrzelicz').addClass('h20');
	$('.przelicz').css('top',r).fadeIn('normal');
	$('.dostawa').addClass('pT30');
}

function setPostponedInfo() {
	$('.js-postponed-info').hover(function() {
		const type = $(this).data('type');
		const content = $('.postponed-info').filter(`[data-type=${type}]`).html();

		showToolBox(this, content, 345);
	}, function() {
		closeToolBox();
	});
}

function setServiceInfo(parent){
	$(parent).find('.serviceInfo').mouseover(function(){
		showToolBox(this,$('.serviceText'+jQuery(this).attr('rel')+':eq(0)').html(),25);
	}).mouseleave(function(){
		closeToolBox();
	});
}

function refreshHolidayPromotionBeforeDeliveryTimeStage() {
	holidayPromotionStatusRefresh('', true);
}

function makeHolidayPromotionRequest(transportDate) {
	holidayPromotionStatusRefresh(transportDate, false);
}

function holidayPromotionStatusRefresh(transportDate, beforeOrderDeliveryTime) {
	$.ajax({
		url:'/holidayPromotionStatusRefresh.ltr',
		method:'POST',
		data: {
			transportDate: transportDate,
			beforeOrderDeliveryTime: beforeOrderDeliveryTime
		},
		success: function(html){
			$('#holidayPromotionContent').html(html);
			$('#holidayPromotionContent a.fancybox').fancybox({
				autoDimensions:	true
			});
		}
	});
}
function refreshHolidayPromotionByTransportDate(transportDate) {
	if(transportDate != '') {
		if (!transportDateAlreadyChoosen) {
			makeHolidayPromotionRequest(transportDate);
			transportDateAlreadyChoosen = true;
		}
	} else {
		if (transportDateAlreadyChoosen) {
			makeHolidayPromotionRequest('');
			transportDateAlreadyChoosen = false;
		}
	}
}

function toggleUserTypeAccount(){
	if($('#company').is(':checked')){
		$('#companyBox').show();
		$('#companyBox input').ignore(false);
		$('#company-name-textarea').ignore(false);
		$('#companyText').addClass('bold');
		$('#individualText').removeClass('bold');
	}
	else {
		$('#companyBox').hide();
		$('#companyBox input').ignore(true).val('').trigger('input');
		$('#company-name-textarea-div').text('').trigger('input');
		$('#company-name-textarea').ignore(true);
		$('#individualText').addClass('bold');
		$('#companyText').removeClass('bold');
	}
}

function toggleUserType(){
	if($('#company').is(':checked')){
		$('#companyNameBox').show();
		$('#company-name-textarea').ignore(false);
		$('#individualUserMessage').hide();
		$('#companyUserMessage').show();
		$('.companyUserMessage').show();
		$('#euNipRow').hide();
		$('#euTaxIdPurchase').prop('checked', false);
		//$('.invoice-type-0, .invoice-type-1').hide();     EUROTM7-128
		//$('.invoice-type-2').show();						EUROTM7-128
		//$('#surnameLabel').html('Nazwisko: ');
		//$('#firstnameLabel').html('Imię: ');
		//$('#surname, #firstname').ignore(true);
	}
	else {
		$('#companyNameBox').hide();
		$('#company-name-textarea').ignore(true).val('');
		$('#company-name-textarea-div').text('').trigger('input');
		$('#userNip').val('').trigger('input');
		$('#individualUserMessage').show();
		$('#companyUserMessage').hide();
		$('.companyUserMessage').hide();
		$('#euNipRow').show();
		//$('.invoice-type-0, .invoice-type-1').show();		EUROTM7-128
		//$('.invoice-type-2').hide();						EUROTM7-128
	}
	InvoiceForm();
}

function invoiceAddressSwitch(force){
	if($('#invoiceAddressFirstname').val()=='' || force=='true')$('#invoiceAddressFirstname').val($('#firstname').val());
	if($('#invoiceAddressSurname').val()=='' || force=='true')$('#invoiceAddressSurname').val($('#surname').val());
	if($('#invoiceAddressStreet').val()=='' || force=='true')$('#invoiceAddressStreet').val($('#homeAddressStreet').val());
	if($('#invoiceAddressHouseNumber').val()=='' || force=='true')$('#invoiceAddressHouseNumber').val($('#homeAddressHouseNumber').val());
	if($('#invoiceAddressFlatNumber').val()=='' || force=='true')$('#invoiceAddressFlatNumber').val($('#homeAddressFlatNumber').val());
	if($('#invoiceZipCode').val()=='' || force=='true')$('#invoiceZipCode').val($('#zipCode').val());
	if($('#invoiceCityName').val()=='' || force=='true')$('#invoiceCityName').val($('#cityName').val());
	if ($('#orderInvoiceNip').val() == '' || force == 'true') $('#orderInvoiceNip').val($('#nipBox .nip').val());
	
	if ($('#invoice-company-name').val() == '' || force == 'true') {
		$('#invoice-company-name-cd').val($('#company-name-cd').val());
	}
	if ($('#orderInvoiceNamePart2').val() == '' || force == 'true') {
		$('#invoice-company-name').val($('#company-name').val());
	}
}

function HomeForm(force){
	if($('#deliveryEqualsHome').is(':checked')){
		$('#delivery-address').slideUp();
		$('#deliveryEqualsHomeF').addClass('bold');
		$('#deliveryEqualsHomeT').removeClass('bold');
		$("#delivery-address input").ignore(true);
		$("#delivery-address .errorBox").removeClass('statusError').removeClass('statusOk');
		$("#delivery-address span.errorText").text('');
		if($('#deliverySelect').val()=='0'){
			deliveryAddressSwitch(force);
		}else{
			updateDeliveryAddress($('#deliverySelect').val());
		}
	}
	else{
		$('#delivery-address input').ignore(false);
		$("#delivery-address").slideDown();
		$('#deliveryEqualsHomeF').removeClass('bold');
		$('#deliveryEqualsHomeT').addClass('bold');
	}
}
function ReceiverForm(force){
	if($('#otherPersonReceipt').is(':checked')){
		$('#receiver-data').slideUp();
		$('#otherPersonReceiptT').addClass('bold');
		$('#otherPersonReceiptF').removeClass('bold');
		$("#receiver-data input").ignore(true);
		$("#receiver-data .errorBox").removeClass('statusError').removeClass('statusOk');
		$("#receiver-data span.errorText").text('');
		if($('#receiverSelect').val()=='0'){
			receiverDataSwitch(force);
		}else{
			updateReceiverData($('#receiverSelect').val());
		}
	}
	else{
		$('#receiver-data input').ignore(false);
		$("#receiver-data").slideDown();
		$('#otherPersonReceiptT').removeClass('bold');
		$('#otherPersonReceiptF').addClass('bold');
	}
}
function deliveryAddressSwitch(force){
	if($('#deliveryAddressStreet').val()=='' || force=='true')$('#deliveryAddressStreet').val($('#homeAddressStreet').val());
	if($('#deliveryAddressStreet').val()=='' || force=='true')$('#deliveryAddressStreet').val();

	if($('#deliveryAddressHouseNumber').val()=='' || force=='true')$('#deliveryAddressHouseNumber').val($('#homeAddressHouseNumber').val());
	if($('#deliveryAddressFlatNumber').val()=='' || force=='true')$('#deliveryAddressFlatNumber').val($('#homeAddressFlatNumber').val());
	if($('#deliveryZipCode').val()=='' || force=='true')$('#deliveryZipCode').val($('#zipCode').val());
	if($('#deliveryCityName').val()=='' || force=='true')$('#deliveryCityName').val($('#cityName').val());
}

function receiverDataSwitch(force){
	//TODO: odkomentować jeśli jest oczekiwane siłowe nadpisanie wartość pól danych odbiorcy w przypadku wybrania nowego odbiorcy i przełączenie formularz na odbiór osobisty i nastepnie na chce podać inne dane odbiorcy
	// if($('#deliveryAddressAddLine1').val()=='' || force=='true')$('#deliveryAddressAddLine1').val($('#firstname').val());
	// if($('#deliveryAddressAddLine2').val()=='' || force=='true')$('#deliveryAddressAddLine2').val($('#surname').val());
	// if($('#realPhoneInputDelivery').val()=='' || force=='true')$('#realPhoneInputDelivery').val($('#phone').val());
}
function noBayServices(){
	if($('#no_service:checked').length)$('.warrantyBox input:checked').not('#no_service').attr('checked',false);
}

function showInvalidVoucherMessage() {
	alert('Nieprawidłowy format kodu rabatowego!');
}

function checkValues(){
	var $voucher=$('#voucherInput');
	var voucher=$voucher.length ? $.trim($voucher.val()) : '';
	var e=0;
	$('#cartForm .quantity input:text').each(function(){
		if(!($(this).val()>0))e=1;
	});
	if(e==1){
		alert('Nieprawidłowa wartość!');
		return false;
	}else if($voucher.length && voucher.length>0 && !/^[0-9a-zA-Z._-]+$/.test(voucher)){
		showInvalidVoucherMessage();
		return false;
	}
	else return true;
}

function setValue(fieldId, fieldValue){
	$('#'+fieldId).val(fieldValue);
}

function incBacks() {
	$('#f_backs').val(($('#f_backs').val()/1)+1);
}

function getBacks(){
	return (-1) * parseInt($('#f_backs').val());
}

function scrollToError(){
	var t=$('label.error:visible, span.error:visible').not('.valid');
	/*t.each(function(){
		try{console.log('błąd: '+$(this).attr('htmlfor'));}catch(e){}
	});*/
	var parent = t.closest('.errorBox');
	if (!parent.length) {
		parent = t.closest('.validate-target');
	}
	console.log(parent)
	if(parent.length)$.scrollTo(parent, 800);
}

function wstecz(){
	$('input, select').ignore(true);
	formAction('BACK');
}

function validateServices() {
	loadingStart();

	var	isDelivery = $('#deliveryEqualsHomeI').prop('checked');
	var cityName = $('#cityName').val();
	var zipCode =  $('#zipCode').val();
	if (isDelivery) {
		cityName = $('#deliveryCityName').val();
		zipCode = $('#deliveryZipCode').val();
	}
	if(!cityName && !zipCode) {
		cityName = $('#invoiceZipCode').val();
		zipCode = $('#invoiceCityName').val();
	}

	$.ajax({
		url: '/order-path-servicesJsonTools.ltr',
		dataType: 'json',
		data: {
			action : 'check_services_to_order_availability',
			cityName: cityName,
			zipCode: zipCode
		},
		success: function(json) {
			var data = json.message;
			if (data != "") {
				$.fancybox('<div class="w300"><div>'+data+'</div><div class="mT10 buttonA"><a class="ok" href="javascript:void(0);" onclick="formAction(\'NEXT\');loadingStart();return false;"></a><div class="clear"></div></div></div>',{autoDimensions:true,onClosed:function(){formAction('NEXT');}});
			}
			else {
				loadingStop();
				formAction('NEXT');
			}
		},error: function(){
			fancyAlert('Wystąpił błąd walidacji. Prosimy odświeżyć stronę i spróbować jeszcze raz');
		}
	});
}

function updateDeliveryAddress(id) {
	var deliveryAddress = [
		{
			input: '#deliveryAddressStreet',
			value: $('#delivery_street_' + id).val()
		},
		{
			input: '#deliveryAddressHouseNumber',
			value: $('#delivery_houseNumber_' + id).val()
		},
		{
			input: '#deliveryAddressFlatNumber',
			value: $('#delivery_flatNumber_' + id).val()
		},
		{
			input: '#deliveryZipCode',
			value: $('#delivery_zipCode_' + id).val()
		},
		{
			input: '#deliveryZipCodeH',
			value: $('#delivery_zipCode_' + id).val()
		},
		{
			input: '#deliveryCityName',
			value: $('#delivery_city_' + id).val()
		}
	];
	validateFormData( deliveryAddress );
}

function updateReceiverData(id) {
	$('#deliveryAddressAddLine1').val($('#delivery_addLine1_' + id).val());
	$('#deliveryAddressAddLine2').val($('#delivery_addLine2_' + id).val());
	$('#realPhoneInputDelivery').val($('#delivery_phone_' + id).val());
}

function updateInvoiceData(id) {
	var invoiceData = [
		{
			input: '#invoiceAddressFirstname',
			value: $('#invoice_addLine1_' + id).val()
		},
		{
			input: '#invoiceAddressSurname',
			value: $('#invoice_addLine2_' + id).val()
		},
		{
			input: '#orderInvoiceNip',
			value: $('#invoice_nip_' + id).val()
		},
		{
			input: '#invoice-company-name-textarea-div',
			value: $('#invoice_company_name_' + id).val()
		},
		{
			input: '#invoiceAddressStreet',
			value: $('#invoice_street_' + id).val()
		},
		{
			input: '#invoiceAddressHouseNumber',
			value: $('#invoice_houseNumber_' + id).val()
		},
		{
			input: '#invoiceAddressFlatNumber',
			value: $('#invoice_flatNumber_' + id).val()
		},
		{
			input: '#invoiceZipCode',
			value: $('#invoice_zipCode_' + id).val()
		},
		{
			input: '#invoiceZipCodeH',
			value: $('#invoice_zipCode_' + id).val()
		},
		{
			input: '#invoiceCityName',
			value: $('#invoice_city_' + id).val()
		}
	];
	if (id === '0') {
		clearInvoiceData(invoiceData);
		return false;
	}
	if (id) {
		validateFormData(invoiceData);
	}
}

function clearInvoiceData(data) {
	data.forEach(function (field) {
		var $element = $(field.input);
		if ($element.is('div[contenteditable]')) {
			$element.text('').trigger('input');
		}
		$element.val('').trigger('input');
	});
}

function validateFormData( data ) {
	data.forEach(function( field ) {
		var $input = $(field.input);
		var value = field.value || '';
		if ($input.is('div[contenteditable]')) {
			$input.text(value).trigger('input');
		} else {
			$input.val(value).trigger('input');
		}
		requestAnimationFrame(function() {
			if($input.length && $input.val() !== '') {
				$('#frontForm').validate().element( field.input );
			}
		});
	});
}


function changePassStart(){
	$('#passForm').validate({
		rules:{
			"passwordOld": {
				required:true
			},
			"passwordNew": {
				required:true,
				minlength: 5
			},
			"passwordNewRepeat": {
				required:true,
				minlength: 5,
				equalTo: "#passwordNew"
			}
		},
		messages:{
			"passwordOld": {
				required:"Podaj stare hasło"
			},
			"passwordNew": {
				required:"Podaj nowe hasło",
				minlength: "Hasło jest za krótkie (5 znaków)"
			},
			"passwordNewRepeat": {
				required:"Powtórz nowe hasło",
				minlength: "Hasło jest za krótkie (5 znaków)",
				equalTo: "Nowe hasła nie są identyczne"
			}
		}
	});
}

function grid1(){
	$('table.grid tr').each(function(){
		$(this).children().each(function(i){
			$(this).data('i',i);
		});
	});
	$('table.grid td.col2').click(function(){
		$(this).find('input')[0].click();
	});
	$(document).mousemove(function(e){
		if(gridCount==0){
			gridCount++;
			$('table.grid td.col2').hover(function(){
				if(gridCount>0){
					clearTimeout(hoverOffTime);
					hoverOnGridTable($(this));
				}

			},function(){
				if(gridCount>0){
					clearTimeout(hoverOffTime);
					hoverOffGridTable();
				}
			});
		}
	});
	clickGridTable($('table.grid input:checked').parents('td'));
	setTimeout(
		function(){
			hoverOnGridTable($('table.grid input:checked').parents('td'));
		},100
	);
}
function showDefaultTooltip(){
	var div=$('#firstDeliveryTimeMessage');
	if(div.length && !$('input[name="day"]:checked').length){
		hoverOnGrid2($('.active:first > a'),div.html());
	}
}

function reloadCartView(loading, callback = null) {
	if(loading == null){
		loading = true
	};
	if(loading){
		loadingStart();
	};
	$.ajax({
		url:'/cart.ltr',
		cache:false,
		async:false,
		success:function(html){
			$('#cart').html(html);
			if(loading){
				loadingStop();
			}
			refreshSharedCart();
			cartStart();
			$('#cart .errorBox').errorBox();
			$("#cart a.fancybox").fancybox({
				autoDimensions:	true
			});
			checkbox('#cart');
			$('#fancybox-content .addedServicesWorth').text($('#content-2c .addedServicesWorth:first').text());
			$('#fancybox-content .addedServicesAll').text($('#content-2c .addedServicesAll:first').text());
			$('.select3-input').select3();
			setPostponedInfo();
			if (callback) {
				callback();
			}

			$(document).trigger('cartRefresh');

		},error:function(){
			fancyOk('Wystąpił błąd odświeżenia strony. Odśwież stronę samodzielnie');
		}
	});
}

function roundEuro(i){
	var tmp=Math.floor(i*1000);
	var mod=tmp%10;
	if(mod==0){
		i=Math.ceil(i*100)/100;
	}else if(mod<6){
		i=Math.floor(i*100)/100;
	}else {
		i=Math.ceil(i*100)/100;
	}
	return i;
}
function price(i){
	i=roundEuro(i)+'';
	i=i.replace('.',',');
	if(i.indexOf(',') == i.length-2 && i.indexOf(',')>-1)i+='0';
	i+=' zł';
	return i;
}

function servicesLayerClick(id, serviceId, that){
	var url=(that.checked)?'/add-services-to-cart.ltr':'/remove-services-from-cart.ltr';
	var data={
		mainItemId:id,
		servicesIds:serviceId,
		addedFrom:'CART_EDIT'
	};
		$.ajax({
			url:url,
			type:'POST',
			data:data,
			cache:false,
			success: function () {
				reloadCartView(false);
			},error:function(){
				fancyOk('Wystąpił błąd dodawania usługi. Prosimy spróbować później lub skontaktować się z obsługą.');
			}
		});
}

function clickServiceChecked(id, serviceId){
	var checked = $('#service'+id+' input:checked').length;
	var l=checked+$('#howManyServicesAlreadyAdded_'+id).val()/1;
	var all=$('#service'+id+' input[type=checkbox]').length;

	if(serviceId) {
		if($('#serviceChecked'+ id +'_'+ serviceId).is(':checked')) {
			$('#quantity'+ id +'_'+ serviceId).show();
			if($('#serviceCount'+ id +'_'+ serviceId).val() == 0) {
				$('#serviceCount'+ id +'_'+ serviceId).val(1);
			}
		} else {
			$('#quantity'+ id +'_'+ serviceId).hide();
		}
	}

	if($('#service'+ id +' .checkbox').is(':checked')) {
		$('#service'+id+' .quantityHeader').show();
	} else {
		$('#service'+id+' .quantityHeader').hide();
	}
	addCartServices(id);
}
function sendServiceEvent(eventTypeName) {
	if (eventTypeName) {
		var event = dataLayer.filter(function(e) {
			return e.eventAction == eventTypeName
		});
		if (event.length == 0) {
			UA.interaction('Potykacz', eventTypeName, 'Wyświetlenie');
		}
	}
}

function removeInvalidServices(deliveryType) {

	$.ajax({
		url:'/cartActions.ltr',
		method: 'post',
		data: {
			action: 'REMOVE_INVALID_SERVICES',
			deliveryType: deliveryType
		},
		success: function (html) {
			reloadCartView(false);
			zamawiam();
		}
	});
}
function showServicesInExcludedDeliveryEncouragement(encouragementContentId){
	var option = {
		autoDimensions : true,
		onComplete : function() {
			$('#fancybox-outer').find('.noSafari').removeClass('noSafari');
			checkbox('#fancybox-outer');
			$.fancybox.resize();
			$('#fancybox-content .servicesRemoveInvalidForHome').click(function() {
				removeInvalidServices(1);
			});
			$('#fancybox-content .servicesRemoveInvalidForShop').click(function() {
				removeInvalidServices(0);
			});
			$('#fancybox-content .servicesRemoveInvalid').click(function() {
				removeInvalidServices();
			});
			setServiceInfo('#fancybox-content');
		}
	};
	var html=$(notAddedServicesOnlyHomeDeliveryEncouragement);
	html.find(encouragementContentId).show();
	$.fancybox(html.html(), option);
	sendServiceEvent(html.find('input[name="eventTypeName"]').val());
}

function ePaymentBankErrorPlacementValidation(error, element){
	error.insertAfter(element.parent());
	error.addClass('errorText');
	if(error.text()!=''){
		element.parents("#ePaymentBanks").find('.errorBox').addClass('statusError');
		element.parents("#ePaymentBanks").find('.errorBox').removeClass('statusOk');
	}
	$('.errorBox').each(function(){
		var span=$(this).find('span.error, label.error');
		if(span.length>1)span.eq(0).remove();
	});
}

function promoteHomeDelivery() {

	if (isPromoteHomeDelivery) {
		showDeliveryNotify();
		return false;
	}

	return true;
}

//funkcje nadpisywane i wykorzystywane do zdarzeń analitycznych
function _orderDeliveryTimeIntervalsEvents(){}

function calculateUserInstalmentOption(){

	setValue('F_ACTION', 'UPDATE_USER_INSTALMENT_OPTION');
	loadingStart();
	$('#cartForm')[0].submit();
}

function changeUserInstalmentOption(instalment, instalmentNumber){

	setValue('instalment', instalment);
	setValue('instalmentNumber', instalmentNumber);
	setValue('F_ACTION', 'CHANGE_USER_INSTALMENT_OPTION');
	loadingStart();
	$('#cartForm')[0].submit();
}

function retriveCart() {

	$.ajax({
		type: "POST",
		url:'/cart.ltr',
		data: {
			c : $("#cookieToRetrieve").val()
		},
		cache:false,
		success:function(html){
			document.location.href='/cart.bhtml';
		},error:function(){
			fancyOk('Wystąpił błąd.');
		}
	});
}

function addServiceFromButton(productId,serviceId) {
	var data={
		mainItemId:productId,
		servicesIds:serviceId,
		addedFrom:'CART_EDIT'
	};
	loadingStart();
	$.ajax({
		url:'/add-services-to-cart.ltr',
		type:'POST',
		data:data,
		cache:false,
		success: function () {
			reloadCartView();
		},error:function(){
			fancyOk('Wystąpił błąd dodawania usługi. Prosimy spróbować później lub skontaktować się z obsługą.');
		}
	});
}

function showETransferRegulation(operator) {
	var $regulation = $("#e-transfer-regulation").removeClass("tpay payu");
	operator = operator || $('.ePaymentBankIco.selected').data('operator');
	if (operator === 'TPAY' || operator === 'PLATNOSCI') {
		if (operator === 'TPAY') {
			$regulation.addClass("tpay");
		}
		if (operator === 'PLATNOSCI') {
			$regulation.addClass("payu");
		}
		if(operator != previousPaymentOperator) {
			previousPaymentOperator = operator;
			$('#e-transfer-agreement').prop('checked',false);
		}
		$regulation.removeClass("e-transfer-regulation-hidden");
		$('#e-transfer-agreement').ignore(false).rules("add", { required: true });
	} else {
		hideETransferRegulation();
	}
}

function zarejestruj(){
	if ($('#registerForm').valid()) {
		emailInvalid.check(function () {
			loadingStart();
			refreshCsrfTokenAndSubmit($('#registerForm'));
		});
	}
}
function zaloguj(){
	if($('#loginForm').valid()){
		loadingStart();
		refreshCsrfTokenAndSubmit($('#loginForm'));
	}
}

function refreshCsrfTokenAndSubmit($form, count=0) {
	function redirectToTargetUrl(url) {
		if(url.startsWith("/") || url.startsWith("http")) {
			loadingStart();
			if(url.indexOf("/simple-login.ltr?login_") == 0) {
				setTimeout(function(){
					$.fancybox({href:url},{
						autoDimensions:	true,
						onComplete:function(){
							fastOrderLoginView();
						}
					});
				},500);
			}else if (url.indexOf("j_spring_security_check")!==-1) {
				$.post({
					url: url,
					success: redirectToTargetUrl
				});
			} else {
				window.location.href = url;
			}
		} else {
			window.location.reload();
		}
	};
	function error403(count){
		$.ajax({
			url: '/refreshCsrf.ltr',
			type: 'GET',
			success: function(newToken) {
				//$form.find("input[name=_csrf]").val(newToken);
				$("meta[name='_csrf']").attr("content",newToken);
				refreshCsrfTokenAndSubmit($form, count);
			}
		});
	}

	$form.find("input[name=_csrf]").remove();
	$form.trigger('agreementSubmit');
	$form.ajaxSubmit({
		success: redirectToTargetUrl,
		statusCode: {
			403: function() {
				count++;
				if(count>2){
					app.alert('Nieudana próby wysłania formularza. Możliwe problemy z obsługą ciasteczek lub blokowaniem treści.');
					return;
				}else{
					error403(count);
				}
			},
			500:function(){
				loadingStop();
				app.alert('Nieudana próba wysłania formularza. Spróbuj ponownie później.')
			}
		}
	});
}

function sendOperatorSource(element) {
	loadingStart();
	var source = $('.operator_source_form').val();
	$.ajax({
		type: "POST",
		url: '/add-source-param.ltr',
		data: {
			operator_source : source,
			from : $('#from').val()
		},
		success: function(result) {
			if(result == 'ok') {
				$('#operator_source_error').addClass("none");
				//jeśli znaleziono klienta który dokonał już zakupu - wypełniany i wysyłany jest formularz "klient zna swój login"
				if($(element).hasClass('previous-client')) {
					$('#frontForm').submit();
				} else {
					$(element).closest('form').submit();
				}
			}
			else {
				loadingStop();
				$('#operator_source_error').removeClass("none");
			}
		},
		error: function() {
			loadingStop();
			$('#operator_source_error').removeClass("none");
		}
	});
}

function needRefresh(md5Sum) {

	var result = false;

	var data=new Object();
	data.md5Sum = md5Sum;

	$.ajax({
		url: '/cartHashChecking.ltr',
		dataType: 'json',
		async: false,
		cache:false,
		data: data,
		success: function(json) {

			if(json.needRefresh) {
				result = true;
				$.fancybox('<div class="w350"><div class="f14 bold tcenter">'
							+ json.cartNeedsRefreshMessage
							+ '</div><div class="clear"></div><div class="buttonA h30 mT10"><a onclick="$.fancybox.close()" class="ok btn btn-primary" href="javascript:void(0)">OK</a><div class="clear"></div></div></div>',{
					autoDimensions:	true,
					onClosed:function(){
						loadingStart();
						document.location.reload();
					}
				});
			}
		},
		error:function(){
			fancyAlert('Błąd modułu odświeżania koszyka');
		}
	});

	return result;
}

function customerStart(){
	$('#passwordForm').validate({
		rules: {
			"emailNew": {
				required:true,
				email:true
			},
			"emailNewRepeat":{
				required:true,
				email:true,
				equalTo: "#emailNew"
			}
		},
		messages: {
			"emailNew": {
				required:"Wpisz adres e-mail",
				email:"Wpisz poprawny adres e-mail"
			},
			"emailNewRepeat":{
				required:"Powtórz adres e-mail",
				email:"Powtórz poprawny adres e-mail",
				equalTo: "Podane adresy nie są identyczne"
			}
		}
	});

	$('#customerForm').validate({
		rules: {
			"passwordNew": {
				strongPassword: true
			},
			"passwordOld": "required",
			"passwordNewRepeat":{
				required:true,
				equalTo: "#passwordNew"
			}
		},
		messages: {
			"passwordOld": "Podaj swoje hasło",
			"passwordNew":{
				required:"Podaj nowe hasło",
				minlength: "Podaj co najmniej 5 znaków"
			},
			"passwordNewRepeat":{
				required:"Powtórz nowe hasło",
				equalTo: "Hasła muszą być identyczne"
			}
		}
	});
}

function hideETransferRegulation() {
	$("#e-transfer-regulation").addClass("e-transfer-regulation-hidden");
	$('#e-transfer-agreement').ignore(true);
}

function summaryStart() {

	$('tr.prod:odd').addClass('odd');
	$('tr.prod').each(function(){
		$(this).prev().children('td').addClass('pB10');
	});
	$('.cart_summarize tr:last td').addClass('pB10');
	$('.cart_summarize tr.small').each(function(){
		if(!($(this).next().hasClass('small')))$(this).children('.list').addClass('lastlist');
	});
	$('.js-trade-doubler').on('load', function() {
		tradeDoublerConfirm($(this).data('order-number'));
	});
}

function showServicesAdjustmentErrorMessages(messages) {
	const html = messages.map(message => `<div>${message}</div>`).join('');

	const content = `
		<div class="w300">
			<div class="pB10">${html}</div>
			<div class="tcenter mT10">
				<button onclick="$.fancybox.close();" class="btn btn-primary">OK</button>
			</div>
		</div>
	`;

	$.fancybox(content, {
		autoDimensions: true,
		onClosed: () => formAction('NEXT')
	});
}

function paymentValidateServices() {
	return $.ajax({
		url: '/order-path-adjust-services-in-order.ltr',
		type: 'POST',
		dataType: 'json'
	});
}

function validateOrderAfterOrderPayment() {
	return $.ajax({
		url:'order-path-validateOrderAfterOrderPaymentEdit.ltr',
		dataType: 'json'
	})
	.fail(() => fancyAlert('Wystąpił błąd walidacji. Prosimy odświeżyć stronę i spróbować jeszcze raz'));
}

function checkVoucherOrNextAction() {
	if (voucherUsed) {
		formAction('CHECK_VOUCHER');
	} else {
		formAction('NEXT');
	}
}

function validateServicesAndContinue() {
	paymentValidateServices()
		.then(response => {
			if (response.status === 'FAIL') {
				showServicesAdjustmentErrorMessages(response.messages);
			} else {
				preValidateForm(checkVoucherOrNextAction)
			}
		})
		.fail(() =>
			fancyAlert('Wystąpił błąd walidacji. Prosimy odświeżyć stronę i spróbować jeszcze raz')
		);
}

function isFrontFormValid() {
	let $form = $('#frontForm');
	let isFormValid = true;

	// giftCardOrder
	if (!$form.length) {
		$form = $('#gift-card-order-form');
		$form.submit();
		isFormValid = false;
	}

	if (!$form.valid()) {
		scrollToError();
		isFormValid = false;
	}

	if($('input.payment-type').length && !$('input.payment-type:checked').length){
		$('.order-navigation').addClass('error error-payment');
		isFormValid = false;
	}

	return isFormValid;
}

function formActionNextContinue() {
	if (!isFrontFormValid()) return false;
	if (containsAnyPostponedWarrantyPayment || containsAnySubscriptionWarrantyPayment) {
		validateOrderAfterOrderPayment()
			.then(data => {
				if (data.status === "FAIL") {
					showResolveWarrantyPaymentConflictEncouragement();
				} else {
					validateServicesAndContinue();
				}
			});
	} else {
		validateServicesAndContinue();
	}
}

function showResolveWarrantyPaymentConflictEncouragement() {
	loadResolveWarrantyPaymentConflictEncouragement()
		.then(html => {
			$.fancybox(html, { 
				autoDimensions: true, 
				showCloseButton: false,
				onClosed: function(){
					if(warrantyConflictModalClosedfromButton === false) {
						UA.interaction('PG ABO na Raty','Kliknięcie','Powrót');
					}
				},
				onComplete: function(){
					UA.interaction('PG ABO na Raty','Wyświetlenie','Popup');
				}
			});
			
		});
}

function loadResolveWarrantyPaymentConflictEncouragement() {
	return $.ajax({
		url: '/order-path-resolve-warranty-payment-conflict-encouragement.ltr'
	}).fail(() => {
		fancyAlert('Wystąpił błąd ładowania gwarancji. Odśwież stronę i spróbuj ponownie.');
	});
}

function updateWarrantyQuestionnaire(){
	var status = true;
	var $invalidQuestions = [];
	var $productList = $('#cart .cart_summarize .cart-warranty-box');
	var $selectedWarranties = $productList.find('.payment-warranties .js-select-warranty.selected:not([data-id="0"])');
	var data = [];
	if($selectedWarranties.length != 0) {
		$productList.each(function(){
			var mainCartItemId = $(this).data('cart');
			var warrantyQuestions = $(this).find('.warranty-question');
			if(warrantyQuestions.length != 0){
				warrantyQuestions.each(function(){
					var $checkedAnswer = $(this).find('input[type=radio]:checked');
					if ($checkedAnswer.length != 0 && mainCartItemId) {
						data.push({
							mainCartItemId: mainCartItemId,
							answerNumber: $checkedAnswer.attr('name').slice($checkedAnswer.attr('name').length - 1)*1,
							answerValue: $checkedAnswer.val()
						});
					}else{
						if($(this).closest('.cart-warranty-box').find('.js-select-warranty.selected:not([data-id="0"])').length != 0){
							$invalidQuestions.push($(this).addClass('error'));
						}
					}
				});
			}
		});
		if($invalidQuestions.length != 0){
			$.scrollTo($invalidQuestions[0].closest('.warranties-questionnaire'));
			app.alert('Uzupełnij odpowiedzi na pytania w ankiecie.');
			return false;
		}

		loadingStart();
		$.ajax({
			url:'/cart-update-warranty-questionnaire.ltr',
			type: 'POST',
			async: false,
			dataType: 'json',
			contentType: 'application/json',
			data: JSON.stringify(data),
			success:function(json){
				loadingStop();
				if(json.status == 'SUCCESS') {
					console.log('warranties saved');
					status=true;
				}else{
					app.alert(json.messages[0]);
					status=false;
				}
			},
			error:function(){
				loadingStop();
				console.log('Nieudana próba wysłania ankiet.');
				status=false;
			}
		});
	}
	return status;
}

function regon({ $box, $nip, $companyName, $city, $street, $houseNumber, $flatNumber, $zipCode }) { 
	function nipValidator(nip) {
		var verificator_nip = new Array(6, 5, 7, 2, 3, 4, 5, 6, 7);
		var n = 0;
		var ile;
		for (var i = 0; i < 9; i++) {
			ile = nip.charAt(i) / 1 * verificator_nip[i] / 1;
			n += ile;
		}
		// walidacja odrzuca nip z samymi zerami
		if (n === 0) {
			return false;
		}
		n %= 11;
		if (n != nip.charAt(9)) {
			return false;
		} else {
			return true;
		}
	}

	
	var savedNip;
	var savedData = {};
	if ($box.length && $nip.length) {
		savedNip = $nip.val();
		function check() {
			var nip = $nip.val().replace(/[\ _\-]/gi, "");
			//if (nip != savedNip) {
			if (nip.length == 10) {
				if (nipValidator(nip)) {
					savedNip = nip;
					return true;
				};
			}
			// }
			return false;
		}
		
		function hide() {
			$box.removeClass('show done');
		}
		function show() {
			$box.addClass('show').removeClass('done');
		}
		function done(json) {
			var $form = $nip.closest('form');
			if ($form.length) {
				if ($companyName.length) {
					$companyName.text(json.companyName).trigger('input');
					$form.validate().element($companyName.next());
				}
				if ($city.length) {
					$city.val(json.city);
					$form.validate().element($city);
				}
				if ($street.length) {
					$street.val(json.street);
					$form.validate().element($street);
				}
				if ($houseNumber.length) {
					$houseNumber.val(json.houseNumber);
					$form.validate().element($houseNumber);
				}
				if ($flatNumber.length) {
					$flatNumber.val(json.flatNumber);
					$form.validate().element($flatNumber);
				}
				if ($zipCode.length) {
					$zipCode.val(json.zipCode);
					$form.validate().element($zipCode);
				}
			}
			$box.addClass('done');
		}

		function change($input, name) {
			if ($input.val() != savedData[name]) {
				$box.removeClass('done');
			}
		}
		function showError() { 
			app.showModal({
				id: 'regon-loading-error',
				header: 'Rejestr REGON jest niedostępny',
				content: 'Nie udało się pobrać danych na podstawie podanego przez Ciebie numeru NIP. Prosimy spróbuj za chwilę lub wprowadź dane ręcznie.',
				buttons: [{
					text: 'Rozumiem',
					click: function () {
						app.closeModal();
					}
				}]
			});
		}

		function load() {
			app.showModal({
			    id: 'regon-loading',
			    close: false,
			    content: '<div>Pobieramy dane firmy.<br/>Może to zająć chwilę</div>',
			    callbackOpen: function () { 
					$.ajax({
						url: '/company-details.ltr?nip=' + savedNip,
						success: function (json) {
							if (json.status === 'SUCCESS') {
								setTimeout(function () {			// czasowo, modal się nie zamykał
									app.closeModal();
									savedData = json;
									done(json);
								}, 400);
							} else if (json.status === 'NOT_FOUND') {
								app.showModal({
									id: 'regon-loading-error',
									header: 'Brak danych w rejestrze REGON',
									content: 'Nie udało się pobrać danych na podstawie podanego przez Ciebie numeru NIP. Prosimy wprowadź dane ręcznie.',
									buttons: [{
										text: 'Rozumiem',
										click: function () {
											app.closeModal();
										}
									}]
								});
							} else {
								showError();
							}
						}, error: function () { 
							showError();
						}
					});
			    }
			});
		}
		$('.js-search-regon', $box).on('click', function () {
			load();
		});
		$nip.on('input', function () {
			if (check()) {
				show();
			} else {
				hide();
			}
		});
		$companyName.on('input', function () {
			if ($companyName.text() != savedData['companyName']) {
				$box.removeClass('done');
			}
		});
		$city.on('input', function () {
			change($city, 'city');
		});
		$street.on('input', function () {
			change($street, 'street');
		});
		$houseNumber.on('input', function () {
			change($houseNumber, 'houseNumber');
		})
		$flatNumber.on('input', function () {
			change($flatNumber, 'flatNumber');
		});
		$zipCode.on('input', function () {
			change($zipCode, 'zipCode');
		});
	}
}
function companyName(prefix){
	function prepare(value) {
		value = '' + clean(value);
		return [value, value.substr(0, 80), value.substr(80, 80)];	// [0] wszystko, [1] pierwsza część, [2] druga część
	}
	function clean(text) {
		return text.replace(/(<([^>]+)>)/g, '').trim();
	}
	function init(prefix) {
		let $input1 = $('#' + prefix);
		if ($input1.length) {
			let $input2 = $('#' + prefix + '-cd');
			$input1.ignore(true);
			$input2.ignore(true);
			let $textarea = $('#' + prefix + '-textarea');
			let $div = $('#' + prefix + '-textarea-div');
			var $form = $input1.closest('form');
			if ($input1.hasClass('init')) {
				let text = $input1.val() + $input2.val();
				$textarea.val(text);
				$div.text(text);
			} else {
				$input1.addClass('init');
				$div.on('input', function () {
					var value = prepare($div.text());
					$textarea.val(value[0]);
					$input1.val(value[1]);
					$input2.val(value[2]);
					if ($textarea.hasClass('error') || value[0].length > 160 || value[0].length == 0) {
						$form.validate().element($textarea);
					}
				});
			}
		}
	}
	init(prefix);
};
/**
 * Moduł do przekazywania informacji o wypełnionych polach formularza dla polis w trybie partnerskim 
 */

function partnerInsurance(){
	var $partnerInsuranceForm, $inputs;
	var data;

	function getInputsData() {
		var params = {};
		$inputs.each(function(){
			if($(this).attr('type') == "radio" && $(this).is(':checked')){
				params[$(this).attr('name')] = $(this).val();
			}else if($(this).attr('type') == "checkbox" && $(this).is(':checked')){
				params[$(this).attr('name')] = $(this).val();
			}else if($(this).attr('type') == "text"){
				params[$(this).attr('name')] = $(this).val();
			}
		});
		return params;
	}

	function setInputsData() {
		var params = getInputsData();
		return JSON.stringify(data) != JSON.stringify(params) ? data = params : false;
	}

	function sendInsuranceData() {
		if(setInputsData()){
			$.ajax({
				url: '/cart-update-insurance-data.ltr',
				type: 'POST',
				data: data,
				success:function(){
					console.log('Dane formularza Likwidacji szkód zapisane poprawnie');
				},
				error:function(){
					console.log('Błąd komunikacji podczas zapisu danych formularza Likwidacji szkód');
				}
			});
		}
	}
	function setElements() {
		$partnerInsuranceForm = $('#partner-insurance-form');
		$inputs = $('input', $partnerInsuranceForm);
	}
	function init(){
		setElements();
		if($partnerInsuranceForm.length){
			sendInsuranceData();
		}
	}
	init();
};

/**
 * Moduł do sterowania sliderem w sekcji RATY -> Dobre Raty, na karcie produktu.
 */

function instalmentTO() {
	var $self, $body, $tabs, $customOptions, $slider, $thumb;
	var currentTab = 0;
	var $instalment;
	var instalmentCode = '';
	var instalmentDuration = 0;
	var warranty;
	var rangeMin = 3;
	var sliderWidth, sliderLength, rangeMin, rangeMax, rangeStep;

	function timeFormat(time){
		if(time==1) {
			return '1 miesiąc';
		} else if(time%10>1 && time%10<5) {
			return time + ' miesiące';
		} else {
			return time + ' miesięcy';
		}
	}
	function startSlider(event) {
		sliderWidth = $slider.width();
		updateSlider(event);
		$body.on('mousemove touchmove', updateSlider);
		$body.on('mouseup touchend mouseleave touchleave', stopSlider);
	}
	function updateSlider(event) {
		var x = event.clientX - $slider.offset().left;
		var y = event.clientY - $slider.offset().top;
		var duration = (Math.max(Math.min(Math.ceil((x / sliderWidth) * sliderLength),sliderLength),1) - 1) * rangeStep + rangeMin;
		if (duration != instalmentDuration) {
			repaintSlider(duration);
		}
	}
	function repaintSlider(duration) {
		var $tab=$('.instalment-option[data-instalment='+currentTab+']');
		var $tab=$('.instalment-option[data-instalment='+currentTab+']');
		$slider = $('.js-instalment-customable', $tab);
		$thumb = $('.js-instalment-thumb', $slider);
		sliderLength = $('.js-range-unit', $slider).length;
		var $pricing = $('.js-instalment-pricing', $tab);
		rangeMin = Math.max($pricing.first().data('option')/1, 1);
		rangeMax = Math.max($pricing.last().data('option')/1, 1);
		rangeStep = Math.max((rangeMax - rangeMin)/(sliderLength-1), 1);
		if(duration){
			duration = Math.min(rangeMax, duration);
			duration = Math.max(rangeMin, duration);
			var position = (duration - rangeMin)/rangeStep + 1 ;
			if(position){
				//console.log(duration, rangeMin, rangeMax, rangeStep, position)
				instalmentDuration = duration;

				var $unit = $('.js-range-unit:nth-child('+position+')', $tab);
				$unit.prevAll().addClass('active');
				$unit.addClass('active');
				$unit.nextAll().removeClass('active');

				var $pricing = $('.js-instalment-pricing[data-option=' + duration + ']');
				$pricing.prevAll().removeClass('selected-pricing');
				$pricing.addClass('selected-pricing');
				$pricing.nextAll().removeClass('selected-pricing');

				$thumb.text(timeFormat(duration));
				$unit.append($thumb);
			}
		}
	}

	function stopSlider(event) {
		$body.off('mousemove touchmove', updateSlider);
		$body.off('mouseup touchend mouseleave touchleave', stopSlider);
	}
	function openInstalmentsTab(duration) {
		tab = $instalment.data('instalment');
		instalmentDuration = duration ? duration : $instalment.data('duration');
		instalmentCode = $instalment.data('code');
		warranty = $instalment.data('warranty');

		$self.removeClass('show-tab-' + currentTab);
		$self.addClass('show-tab-' + tab);
		currentTab = tab;
		repaintSlider(instalmentDuration);
	}

	function setEvents(){
		$tabs.on('click', function() {
			$instalment = $(this);
			openInstalmentsTab();
		});
		$slider.on('mousedown touchstart', function(event) {
			startSlider(event);
		});
		$slider.on('dragstart', function(event) {
			event.preventDefault();
		});
		$('.js-set-installment-option').click(function(){
			changeUserInstalmentOption(instalmentCode, instalmentDuration);
		});
		$('.js-instalment-popup', $self).click(function (e) {
			e.preventDefault();
			const modalId = $(this).data('modal');
			app.showModal({
				id: 'modal-instalment-' + modalId,
				content: $('#instalment-' + modalId)
			});
		});
	}
	function setElements() {
		$self = $('#installments');
		$body = $('body');
		$tabs = $('.js-tab', $self);
		$slider = $('.js-instalment-customable', $self);
	}
	function init(){
		setElements();
		setEvents();
		var activeTab = $self.data('code');
		var activeDuration = $self.data('duration');
		var activeTabIndex = 0;
		$tabs.each(function(i,n){
			if($(n).data('code') == activeTab){
				activeTabIndex = i;
			}
		});
		//console.log(activeTabIndex, activeDuration)
		$instalment = $($tabs[activeTabIndex]);
		openInstalmentsTab(activeDuration);
	}
	init();
};
